import React from 'react';

import classNames from '../utils/classnames';

export interface IPageHeadingProps {
  /** Breadcrumb / title / status — left. */
  leftSide?: React.ReactNode;
  /** Actions — right, primary action last. */
  rightSide?: React.ReactNode;
  noMarginBottom?: boolean;
}

/** One-row page header: white bar with a bottom border. */
export const PageHeading: React.FC<IPageHeadingProps> = (props) => {
  const { leftSide, rightSide, noMarginBottom } = props;

  return (
    <header
      className={classNames(
        'flex min-h-15.5 items-center justify-between gap-3 border-b border-border bg-surface px-7 py-3.5',
        !noMarginBottom && 'mb-6',
      )}
    >
      <div className="flex min-w-0 items-center gap-2.5">{leftSide}</div>

      {rightSide != null && <div className="flex shrink-0 items-center justify-end gap-2">{rightSide}</div>}
    </header>
  );
};
